import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar as Snack } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const Snackbar = ({
    open,
    autoHideDuration,
    handleClose,
    message,
    vertical,
    horizontal,
    severity,
}) => (
    <Snack
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
    >
        <Alert
            onClose={handleClose}
            severity={severity}
            elevation={6}
            variant="filled"
        >
            {message}
        </Alert>
    </Snack>
);

export default Snackbar;

Snackbar.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
    severity: PropTypes.string,
    autoHideDuration: PropTypes.number,
};

Snackbar.defaultProps = {
    vertical: 'top',
    horizontal: 'center',
    open: false,
    severity: 'warning',
    autoHideDuration: 6000,
};
